import React from 'react'

import { Flex } from '../../../components/FlexBox'
import { Text } from '../../../components/common/Text'
import SmallButton from './SmallButton'
import Pill from './Pill'
import TitleCellContent from '../../../components/cell/TitleCellContent'
import useTranslation from '../../../hooks/useTranslation'
import { maxItemsForFeed } from '../constants'
import { IContentFeed } from '../queries/getContentFeeds'
import { TableCol, TableRow } from './Table'

const EMPTY = '—'

interface ContentFeedRowProps {
  feed: IContentFeed
  position: number
  onConfigure: () => void
}

export const ContentFeedRow = ({
  feed,
  position,
  onConfigure
}: ContentFeedRowProps) => {
  const { t } = useTranslation()

  return (
    <TableRow>
      <TableCol style={{ maxWidth: 48, minWidth: 48 }}>
        <Text>{position}</Text>
      </TableCol>
      <TableCol style={{ minWidth: 220 }}>
        <TitleCellContent
          item={{ title: feed.name, subtitle: feed.description ?? undefined }}
          onPress={onConfigure}
        />
        {/* Capacity, not just a count: the useful question is whether there is
            room left, which a bare number does not answer. */}
        <Text styles={{ fontSize: 12 }}>
          {t('contentCuration:list:capacity', {
            count: feed.boostCount,
            max: maxItemsForFeed(feed.slug)
          })}
        </Text>
      </TableCol>
      <TableCol style={{ minWidth: 200 }}>
        <Flex flexDirection="row" alignItems="center" flexWrap="wrap">
          {!feed.topics.length && <Text>{EMPTY}</Text>}
          {feed.topics.map(topic => (
            <Pill key={topic.id}>{topic.name}</Pill>
          ))}
        </Flex>
      </TableCol>
      <TableCol style={{ maxWidth: 220, minWidth: 200 }}>
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          {/* Read-only here. Enabling a feed is done on its own page, next to
              the settings that decide whether it is ready to be seen. */}
          <Text styles={{ fontSize: 12, marginRight: 12 }}>
            {feed.enabled
              ? t('contentCuration:list:enabled')
              : t('contentCuration:list:disabled')}
          </Text>
          <SmallButton
            label={t('contentCuration:configure')}
            onPress={onConfigure}
          />
        </Flex>
      </TableCol>
    </TableRow>
  )
}

export default ContentFeedRow
